import { FC, memo } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConversationPanelRenderer from "../conversation/ConversationPanelRenderer";
import LookupFragment from "../../containers/fragments/LookupFragment";
import CustomerDataPanel from "../../containers/fragments/CustomerDataPanel";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { dxpLayout, getMediaColor, getMediaIcon } from "../../../style/theme";
import { Allotment } from "allotment";
import "allotment/dist/style.css";

interface IProps {
  workItem: IWorkItem;
  selectedWorkItemId: string;
  cancelWorkItem: () => void;
}

const RootContainer = styled.div<{ isSelected: boolean }>`
  height: ${(props) => (props.isSelected ? "100%" : "0")};
  display: ${(props) => (props.isSelected ? "flex" : "hidden")};
  overflow: hidden;
`;

const Header = styled.div<{ color: string; isLeftDecorationEnabled: boolean }>`
  height: ${dxpLayout.workItemHeaderHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 0.5rem;
  ${(props) => props.isLeftDecorationEnabled && `padding-left: 1rem;`}
  ${(props) =>
    props.isLeftDecorationEnabled && `border-left:  8px solid ${props.color};`}
  border-bottom: 1px solid ${(props) => props.theme.default};
  background-color: ${(props) => props.theme.primary};
`;

const ConversationContainer = styled.div`
  height: 100%;
  z-index: 99999;
  filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04))
    drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
`;

const CustomerContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const HeaderTitle = styled.div`
  font-weight: 400;
  padding-left: 1rem;
`;

const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const WorkItemPanelPresenter: FC<IProps> = memo(
  ({ workItem, selectedWorkItemId, cancelWorkItem }) => {
    const isLookUp = workItem.workItemState === "LookUp";
    const isSelected = workItem.workItemId === selectedWorkItemId;
    const icon = getMediaIcon(workItem.primaryMediaType,workItem.primaryChannelType,isSelected);
    const color = getMediaColor(workItem.primaryMediaType,workItem.primaryChannelType);

    return (
      <RootContainer isSelected={workItem.workItemId === selectedWorkItemId}>
        <Allotment>
          <Allotment.Pane minSize={400} preferredSize={"50%"}>
            <ConversationContainer>
              <Header color={color} isLeftDecorationEnabled={true}>
                <HeaderTextContainer>
                  <FontAwesomeIcon icon={icon} color={color} />
                  <HeaderTitle>{workItem.primaryMediaType}</HeaderTitle>
                </HeaderTextContainer>
                {isLookUp && (
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    color={color}
                    style={{ cursor: "pointer" }}
                    onClick={cancelWorkItem}
                  />                )}
              </Header>
              {isLookUp ? (
                <LookupFragment workItem={workItem} />
              ) : (
                <ConversationPanelRenderer workItem={workItem} />
              )}
            </ConversationContainer>
          </Allotment.Pane>
          {!isLookUp && (
            <Allotment.Pane minSize={400} preferredSize={"50%"} snap>
              <CustomerContainer>
                <Header color="" isLeftDecorationEnabled={false}>
                  <HeaderTitle>Customer Data</HeaderTitle>
                </Header>
                <CustomerDataPanel workItem={workItem} />
              </CustomerContainer>
            </Allotment.Pane>
          )}
        </Allotment>
      </RootContainer>
    );
  }
);

export default WorkItemPanelPresenter;
